import { AuthService } from '@services/auth/auth.service';
import { ThemeElement } from './theme-element';
import { Injectable } from '@angular/core';
import { ThemeCode } from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  constructor(private authService: AuthService) {}

  /**
   * imposta il tema utente definito dal token
   */
  setCompanyTheme(): void {
    const value = this.authService.getAuthUserAttributes().company;

    this.setTheme('companyTheme', value);
  }

  /**
   * imposta il tema area di base
   */
  setDefaultAreaTheme(): void {
    this.setAreaTheme('default');
  }

  /**
   * imposta il tema area di base richiesto
   */
  setAreaTheme(themeCode: ThemeCode): void {
    this.setTheme('areaTheme', themeCode);
  }

  /**
   * imposta il tema
   */
  setTheme(code: 'companyTheme' | 'areaTheme', value?: string): void {
    const el = this.getBodyElement();

    if (value) {
      el.setDataAttribute(code, value);
    } else {
      el.removeDataAttribute(code);
    }
  }

  /**
   * restituisce il valore della variabile css
   */
  getStyleValue(name: string): string {
    const bodyEl = document.getElementsByTagName('body').item(0);

    if (bodyEl) {
      return getComputedStyle(bodyEl).getPropertyValue(name);
    } else {
      return null;
    }
  }

  /**
   * restituisce l'elemento body
   */
  private getBodyElement(): ThemeElement {
    return new ThemeElement(document.getElementsByTagName('body')[0]);
  }
}
